<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- CNS智能中枢上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>CNS智能中枢</h1>
            <p>
              高效汇聚海量数据，整合不同空间、设备割裂的数据和能力，展示出数据汇聚
              和融合的价值，辅助我们科学决策、事件处置和联动指挥实现更高效顺畅。
            </p>
          </div>
          <div class="security_picture">
            <img src="~@/assets/images/IntelligentHub2.png" />
          </div>
        </el-col>
      </el-row>
      <!-- CNS智能中枢 -->
      <el-row>
        <el-col :span="24">
          <div class="intelligent_hub">
            <ul>
              <li>
                <p>L1<br />数字化</p>
                <img src="~@/assets/images/IntelligentHub3.png" />
              </li>
              <li>
                <p>L2<br />自动化</p>
                <img src="~@/assets/images/IntelligentHub3.png" />
              </li>
              <li>
                <p>L3<br />标准化</p>
                <img src="~@/assets/images/IntelligentHub3.png" />
              </li>
              <li>
                <p>L4<br />智能化</p>
                <img src="~@/assets/images/IntelligentHub3.png" />
              </li>
              <li>
                <p>L5<br />拟人化</p>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>

      <!-- CNS智能中枢 -->
      <el-row>
        <el-col :span="24">
          <el-row>
            <div class="intelligent_hubBottom">
              <div><img src="~@/assets/images/IntelligentHub4.png" /></div>
              <p>L1数字化</p>
              <ul>
                <li>
                  <img src="~@/assets/images/IntelligentHub9.png" />
                  <span>模拟+数字信号，手动配网</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub10.png" />
                  <span>多协议对接</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub11.png" />
                  <span>多物模型适配</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub12.png" />
                  <span>支持云端计算</span>
                </li>
              </ul>
            </div>
          </el-row>
          <el-row>
            <div class="intelligent_hubBottom">
              <div><img src="~@/assets/images/IntelligentHub5.png" /></div>
              <p>L2自动化</p>
              <ul>
                <li>
                  <img src="~@/assets/images/IntelligentHub13.png" />
                  <span>设备自组网</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub14.png" />
                  <span>远程双向控制</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub15.png" />
                  <span>云端、边缘自适应计算</span>
                </li>
              </ul>
            </div>
          </el-row>
          <el-row>
            <div class="intelligent_hubBottom">
              <div><img src="~@/assets/images/IntelligentHub6.png" /></div>
              <p>L3标准化</p>
              <ul>
                <li>
                  <img src="~@/assets/images/IntelligentHub16.png" />
                  <span>人、物、空间有机组合</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub17.png" />
                  <span>自适应标准协议</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub18.png" />
                  <span>自适应物模型</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub19.png" />
                  <span>标准功能模块可配置</span>
                </li>
              </ul>
            </div>
          </el-row>
          <el-row>
            <div class="intelligent_hubBottom">
              <div><img src="~@/assets/images/IntelligentHub7.png" /></div>
              <p>L4智能化</p>
              <ul>
                <li>
                  <img src="~@/assets/images/IntelligentHub20.png" />
                  <span>专家知识库</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub21.png" />
                  <span>自主Ai算法</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub22.png" />
                  <span>多场景多设备联动</span>
                </li>
              </ul>
            </div>
          </el-row>
          <el-row>
            <div class="intelligent_hubBottom">
              <div><img src="~@/assets/images/IntelligentHub8.png" /></div>
              <p>L5拟人化</p>
              <ul>
                <li>
                  <img src="~@/assets/images/IntelligentHub23.png" />
                  <span>全面感知的泛在物联网</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub24.png" />
                  <span>全设备的自动识别</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub25.png" />
                  <span>基于人因工程的主动交互</span>
                </li>
                <li>
                  <img src="~@/assets/images/IntelligentHub26.png" />
                  <span>空间即服务</span>
                </li>
              </ul>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/IntelligentHub1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    margin-bottom: 40px;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 256px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      p {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        width: 620px;
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        line-height: 30px;
      }
    }
    .security_picture {
      position: absolute;
      top: 25px;
      right: 261px;
      width: 558px;
      height: 412px;
    }
  }

  //智能中枢
  .intelligent_hub {
    // width: 1400px;
    background: #fefefe;
    border-radius: 5px;
    // margin: auto;
    border: 1px #fafafa solid;
    margin: 40px 235px 36px 256px;
    padding: 20px 50px;
    ul {
      display: flex;
      justify-content: space-between;
      li {
        list-style: none;
        display: flex;
        align-items: center;
        p {
          background: #f8fafc;
          border-radius: 50%;
          font-size: 20px;
          font-family: MicrosoftYaHeiLight;
          font-weight: bold;
          padding: 31px 27px;
          margin-right: 65px;
        }
        img {
          margin-right: 51px;
        }
      }
      > li:nth-of-type(5) p {
        margin-right: 0;
      }
    }
  }

  .intelligent_hubBottom {
    display: flex;
    justify-content: space-between;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    margin: 0 236px 0 241px;
    align-items: center;
    border-bottom: 1px #eeeeee solid;
    padding: 57px 0 57px 58px;
    > div {
      width: 208px;
      height: 167px;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    > p {
      font-size: 20px;
      padding-right: 40px;
    }
    ul {
      width: 50%;
      text-align: left;
      padding-left: 12%;
      li {
        list-style: none;
        width: 260px;
        display: inline-block;
        img {
          vertical-align: middle;
        }
        > span {
          margin-left: 16px;
          font-size: 16px;
        }
      }

      li:nth-of-type(1),
      li:nth-of-type(3) {
        margin-right: 97px;
      }

      li:nth-of-type(3),
      li:nth-of-type(4) {
        margin-top: 68px;
      }
    }
  }
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .intelligent_hub {
      // margin: 40px 4% 36px 10%;
    }
    .intelligent_hubBottom {
      // margin: 0 8% 0 12%;
      > div {
        // width: 1.45rem;
      }
      ul {
        width: 50% !important;
        li {
          width: 1.6rem;
        }

        li:nth-of-type(1),
        li:nth-of-type(3) {
          margin-right: 27px;
        }
      }
    }
    .intelligent_hub ul li p {
      margin-right: 33px;
    }

    .scene_top {
      height: 3.2rem;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "CNS智能中枢-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content: "CNS智能中枢,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content: "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能CNS智能中枢高效汇聚海量数据，整合不同空间、设备割裂的数据和能力，展示出数据汇聚 和融合的价值，辅助我们科学决策、事件处置和联动指挥实现更高效顺畅。",
      },
    ],
  },
  data() {
    return {
      tabIndex: "2-1",
    };
  },
  methods: {},
  computed: {},
};
</script>